import styled from "styled-components";

export const Heading = styled.h2`
    max-width: 288px;
    font-size: 16px;
    font-weight: 900;
    color: #333333;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 1px rgba(0,0,0,0.2) solid;
    span{
        font-weight: 400;
    }
`;